// TODO - make this configurable per environment
export const LogglyToken = "4c334862-073b-4e15-90aa-265ebf33b30e"; // Loggly token
export const LogglyUrl = "https://logs-01.loggly.com/";
export const LogglyTag = "/tag/Lobby"; // use for Logging for specific Tag
export const LogglyBulkType = "bulk/"; // for bulk Logging/Update(multiple updates)
export const LogglyInputType = "inputs/"; // for Logging single event
